import { OperatorPortalWorkPage } from "@/components/non_registrant/operator-portal-pages";
import { OrdinancesDeepLinkProvider } from "@/components/non_registrant/ordinances-deep-link-context";
import type { OrdinancesSearchState } from "@/lib/ordinances-search";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback, useMemo } from "react";

const validateWorkSearch = (search: Record<string, unknown>) => ({
  licenseId: (search.licenseId as string) || undefined,
});

export const Route = createFileRoute("/operator/ordinances")({
  validateSearch: (
    search: Record<string, unknown>,
  ): OrdinancesSearchState & {
    licenseId?: string;
  } => ({
    ...validateWorkSearch(search),
    jurisdictionId:
      typeof search.jurisdictionId === "string"
        ? search.jurisdictionId
        : undefined,
    configurationId:
      typeof search.configurationId === "string"
        ? search.configurationId
        : undefined,
    licenseTypeId:
      typeof search.licenseTypeId === "string"
        ? search.licenseTypeId
        : undefined,
    versionId:
      typeof search.versionId === "string" ? search.versionId : undefined,
    new: search.new === true || search.new === "true",
  }),
  component: OperatorOrdinancesRoute,
});

function OperatorOrdinancesRoute() {
  const fullSearch = Route.useSearch();
  const navigate = useNavigate();

  const ordinancesSearch = useMemo(
    (): OrdinancesSearchState => ({
      jurisdictionId: fullSearch.jurisdictionId,
      configurationId: fullSearch.configurationId,
      licenseTypeId: fullSearch.licenseTypeId,
      versionId: fullSearch.versionId,
      new: fullSearch.new,
    }),
    [
      fullSearch.jurisdictionId,
      fullSearch.configurationId,
      fullSearch.licenseTypeId,
      fullSearch.versionId,
      fullSearch.new,
    ],
  );

  const onClear = useCallback(() => {
    navigate({
      to: "/operator/ordinances",
      search: (prev) => ({
        ...prev,
        jurisdictionId: undefined,
        configurationId: undefined,
        licenseTypeId: undefined,
        versionId: undefined,
        new: undefined,
      }),
      replace: true,
    });
  }, [navigate]);

  return (
    <OrdinancesDeepLinkProvider
      value={{ initialSearch: ordinancesSearch, onClearInitialSearch: onClear }}
    >
      <OperatorPortalWorkPage />
    </OrdinancesDeepLinkProvider>
  );
}
